import { render, staticRenderFns } from "./SelectFont.vue?vue&type=template&id=8e4e9634&scoped=true&"
import script from "./SelectFont.vue?vue&type=script&lang=js&"
export * from "./SelectFont.vue?vue&type=script&lang=js&"
import style0 from "./SelectFont.vue?vue&type=style&index=0&id=8e4e9634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e9634",
  null
  
)

export default component.exports